const ACTIONS_NAMESPACE = 'MAILCHIMP_CONNECTIONS_TABLE';

export const SET_CONNECTIONS_ORDER_BY = `${ACTIONS_NAMESPACE}__SET_CONNECTIONS_ORDER_BY`;

export const setConnectionsOrderBy = connectionsOrderBy => ({
  type: SET_CONNECTIONS_ORDER_BY,
  payload: { connectionsOrderBy },
});
